<template>
  <div class="wrapper">
    <div class="fixed bg-black/30 h-full w-full inset-0 z-50" v-if="open">
      <div class="popup relative">
        <i @click="open = false" class="fa-solid fa-circle-xmark closer"></i>
        <iframe class="pdf" src="/rules.pdf" width="100%" height="100%">
        </iframe>
      </div>
    </div>
    <header>
      <router-link to="/"
        ><img src="@/assets/images/logo-mixa-min.png"
      /></router-link>
    </header>
    <main class="h-full bg-white flex items-center justify-center">
      <div>
        <img class="jeu" src="@/assets/images/quiz.png" />
        <img src="@/assets/images/mixa2-min.png" class="homeimg" />
      </div>
    </main>
    <footer>
      <div class="bg-white flex flex-wrap -mt-1 justify-center">
        <router-link to="/questions"><button>JE PARTICIPE</button></router-link>
        <p
          @click="open = true"
          class="w-full text-center gothambook rules absolute z-40"
        >
          *Règlement du quiz à retrouver dans le
          <a>popup</a> ou sur mixa.fr
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  components: {},

  data() {
    return {
      open: false,
      url: "/rules.pdf",
    };
  },
};
</script>

<style>
.pdf {
  width: 100%;
  aspect-ratio: 4 / 3;
}

.pdf {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
